module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Binocular-6f7a249513cb1d9c9103b6f690bb0be2.svg";